/**
 * @description: 寄存作废明细报表
 * @author: lyr
*/
<template>
    <div class="war-jczfm-report">
        <div class="jm-list" v-show="showList">
            <el-form :inline="true" size="small" :model="jm_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="jm_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="jm_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="jm_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="jm_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="jm_list_form.content">
                        <el-select class="el-slot-select" v-model="jm_list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="寄存单号" value="relation_id"></el-option>
                            <el-option label="姓名" value="user_name"></el-option>
                            <el-option label="手机号" value="mobile"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="jmQuery">查询</el-button>
                    <el-button @click="jmExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="jm_list">
                <el-table-column prop="deleted_at" label="作废操作时间"></el-table-column>
                <el-table-column prop="deleted_name" label="操作人"></el-table-column>
                <el-table-column prop="number" label="寄存单号"></el-table-column>
                <el-table-column width="150" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="user_name" label="姓名"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="deleted_reason" label="备注"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="toDetail(scope.row)">寄存单详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="jm_list_page"
                :total="jm_list_total"
                @current-change="getJmList">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="jm_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="jm_export_sign" v-model="jm_export_all" @change="jmExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="jm_export_ids" @change="jmExportChange">
                    <el-checkbox label="deleted_at">作废操作时间</el-checkbox>
                    <el-checkbox label="deleted_name">操作人</el-checkbox>
                    <el-checkbox label="number">寄存单号</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="user_name">姓名</el-checkbox>
                    <el-checkbox label="mobile">手机号</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="jm_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="jm_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
        <div class="deposit-det" v-show="showDepsitDet">
            <div class="row">
                <button type="button" class="btn btn-flat btn-small btn-orange" @click="backList">返回</button>
            </div>
            <div class="deposit-det-list">
                <h2>存酒单详情 - {{det_status}}</h2>
                <div class="row clearfix" v-if="theDeposit.status == '1'">
                    <div class="col-md-4">
                        <label class="col-md-4">门店：</label>
                        <span class="col-md-8">{{theDeposit.shop_name}}</span>
                        <label class="col-md-4">寄存来源：</label>
                        <span class="col-md-8">{{theDeposit.type_name}}</span>
                        <label class="col-md-4">用户姓名：</label>
                        <span class="col-md-8">{{theDeposit.user_name}}</span>
                    </div>
                    <div class="col-md-4">
                        <label class="col-md-4">寄存包厢：</label>
                        <span class="col-md-8">{{theDeposit.room_name}}</span>
                        <label class="col-md-4">微信昵称：</label>
                        <span class="col-md-8">{{theDeposit.ahead_user_name}}</span>
                        <label class="col-md-4">备注：</label>
                        <span class="col-md-8">{{theDeposit.remark}}</span>
                    </div>
                    <div class="col-md-4">
                        <label class="col-md-4">存酒单号：</label>
                        <span class="col-md-8">{{theDeposit.number}}</span>
                        <label class="col-md-4">手机号：</label>
                        <span class="col-md-8">{{theDeposit.mobile}}</span>
                        <label class="col-md-4">存酒码：</label>
                        <span class="col-md-8">{{theDeposit.take_code}}</span>
                    </div>
                </div>
                <div class="row clearfix" v-else>
                    <div class="col-md-4">
                        <label class="col-md-4">门店：</label>
                        <span class="col-md-8">{{theDeposit.shop_name}}</span>
                        <label class="col-md-4" v-if="theDeposit.status == '6' || theDeposit.status == '7'">更新时间：</label>
                        <span class="col-md-8" v-if="theDeposit.status == '6' || theDeposit.status == '7'">{{theDeposit.update_time}}</span>
                        <label class="col-md-4">寄存来源：</label>
                        <span class="col-md-8">{{theDeposit.type_name}}</span>
                        <label class="col-md-4">用户姓名：</label>
                        <span class="col-md-8">{{theDeposit.user_name}}</span>
                        <label class="col-md-4">备注：</label>
                        <span class="col-md-8">{{theDeposit.remark}}</span>
                    </div>
                    <div class="col-md-4">
                        <label class="col-md-4">寄存包厢：</label>
                        <span class="col-md-8">{{theDeposit.room_name}}</span>
                        <label class="col-md-4" v-if="theDeposit.status == '4' || theDeposit.status == '7'">配送包厢：</label>
                        <span class="col-md-8" v-if="theDeposit.status == '4' || theDeposit.status == '7'">{{theDeposit.to_room_name}}</span>
                        <label class="col-md-4">寄存时间：</label>
                        <span class="col-md-8">{{theDeposit.create_time}}</span>
                        <label class="col-md-4" v-if="theDeposit.status == '2'">不通过时间：</label>
                        <span class="col-md-8" v-if="theDeposit.status == '2'">{{theDeposit.update_time}}</span>
                        <label class="col-md-4" v-if="theDeposit.status != '2'">寄存服务员：</label>
                        <span class="col-md-8" v-if="theDeposit.status != '2'">{{theDeposit.server_name}}</span>
                        <label class="col-md-4">微信昵称：</label>
                        <span class="col-md-8">{{theDeposit.ahead_user_name}}</span>
                    </div>
                    <div class="col-md-4">
                        <label class="col-md-4">存酒单号：</label>
                        <span class="col-md-8">{{theDeposit.number}}</span>
                        <label class="col-md-4">到期时间：</label>
                        <span class="col-md-8">{{theDeposit.end_time}}</span>
                        <label class="col-md-4">寄存操作人：</label>
                        <span class="col-md-8">{{theDeposit.admin_name}}</span>
                        <label class="col-md-4">手机号：</label>
                        <span class="col-md-8">{{theDeposit.mobile}}</span>
                        <label class="col-md-4">存酒码：</label>
                        <span class="col-md-8">{{theDeposit.take_code}}</span>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <h3>寄存详情</h3>
                <table class="table table-bordered table-hover" data-pagination="true" ref="depositDetTable"></table>
            </div>
            <div class="table-responsive" v-show="theDeposit.take_goods && theDeposit.take_goods.length != '0'">
                <h3 v-if="theDeposit.status != '4'">取酒详情</h3>
                <h3 v-if="theDeposit.status == '4'">配送详情</h3>
                <table class="table table-bordered table-hover" data-pagination="true" ref="depositWineTable"></table>
            </div>
            <div class="table-responsive">
                <h3>操作记录</h3>
                <table class="table table-bordered table-hover" data-pagination="true" ref="depositDetOperLogTable"></table>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'war_jczfm_report',
        data() {
            return {
                showList: true,
                showDepsitDet: false,
                loading: false,
                shop_list: [],
                jm_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'relation_id',
				},
				jm_list: [],
				jm_list_page: 1,
                jm_list_total: 0,
                jm_export_sign: false,
				jm_export_all: false,
                jm_export_ids: [],
                jm_export_list: [ 'deleted_at', 'deleted_name', 'number', 'shop_name', 'user_name', 'mobile'],
                jm_export_type: '1',

                det_status: '',
                theDeposit: {},
                oper_log_list: [], // 清空操作日志
            }
        },
        mounted: function() {
            this.jm_list_form.start_time = moment().subtract(30, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.jm_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.jm_list_form.shop_id = this.shop_list[0].id;
                this.getJmList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.jm_list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jm_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.jm_list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jm_list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.jm_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(30, 'day').hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.jm_list_form.start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.jm_list_form.end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },
            
            getJmList(page) {
				const _this = this;

                _this.loading = true;
                let relation_id = "",
                    user_name = "",
                    mobile = "";
                if(_this.jm_list_form.select == 'relation_id') {
                    relation_id = _this.jm_list_form.content;
                } else if(_this.jm_list_form.select == 'user_name') {
                    user_name = _this.jm_list_form.content;
                } else if(_this.jm_list_form.select == 'mobile') {
                    mobile = _this.jm_list_form.content;
                }
				Vue.axios.post('Deposit/searchDeletedDepositList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.jm_list_form.start_time,
                            "end_time": _this.jm_list_form.end_time,
                            "shop_id": _this.jm_list_form.shop_id,
                            "number": relation_id,
                            "user_name": user_name,
                            "mobile": mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jm_list_total = Number(res.data.response.result.total);
						}
						_this.jm_list = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			jmQuery() {
				this.getJmList(1);
            },
            // 导出
            jmExportAll(val) {
				this.jm_export_ids = val ? this.jm_export_list : [];
				this.jm_export_sign = false;
			},
			jmExportChange(val) {
				const len = val.length;
				this.jm_export_all = len === this.jm_export_list.length;
				this.jm_export_sign = len > 0 && len < this.jm_export_list.length;
			},
            jmExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "Deposit/exportDeleteDepositList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.jm_export_ids = res.data.response.result.export_fields;
                            _this.jm_export_type = res.data.response.result.export_type;
                        } else {
                            _this.jm_export_ids = _this.jm_export_list;
                            _this.jm_export_type = '1';
                        }
                        _this.jmExportChange(_this.jm_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.jm_list_export)
                }, function() {
                    _this.jmExport();
                });
            },
            jmExport: function() {
                let relation_id = "",
                    user_name = "",
                    mobile = "";
                if(this.jm_list_form.select == 'relation_id') {
                    relation_id = this.jm_list_form.content;
                } else if(this.jm_list_form.select == 'user_name') {
                    user_name = this.jm_list_form.content;
                } else if(this.jm_list_form.select == 'mobile') {
                    mobile = this.jm_list_form.content;
                }
                window.location.href = Vue.ctUrl + "Deposit/exportDeleteDepositList?" +
                    "&start_time=" + this.jm_list_form.start_time +
                    "&end_time=" + this.jm_list_form.end_time +
                    "&shop_id=" + this.jm_list_form.shop_id +
                    "&number=" + relation_id +
                    "&user_name=" + user_name +
                    "&mobile=" + mobile +
                    "&export_fields=" + JSON.stringify(this.jm_export_ids) +
                    "&export_type=" + this.jm_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
            toDetail: function (row) {
                this.det_status = row.status_name
                this.getDepositDet(row.id);
                this.showList = false;
                this.showDepsitDet = true;
            },

            // 详情页
            backList: function () {
                this.showList = true
                this.showDepsitDet = false
            },

            // 获取寄存管理详情
            getDepositDet: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Deposit/getDepositDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.theDeposit = data.response.result;
                            _this.innitDetTable();
                            _this.innitWineTable();
                            _this.innitDetOperLogTable();
                            
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化寄存详情
            innitDetTable: function() {
                let _this = this;
                $(_this.$refs.depositDetTable).bootstrapTable("destroy");
                $(_this.$refs.depositDetTable).bootstrapTable({
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: '20%'
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: '20%'
                    }, {
                        field: "quantity",
                        title: "寄存数量",
                        width: '20%'
                    }],
                    data: _this.theDeposit.goods
                });
            },
            // 初始化取酒详情
            innitWineTable: function() {
                let _this = this;
                $(_this.$refs.depositWineTable).bootstrapTable("destroy");
                $(_this.$refs.depositWineTable).bootstrapTable({
                    columns: [{
                        field: "creare_time",
                        title: "取酒时间",
                        width: '25%'
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: '25%'
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: '25%'
                    }, {
                        field: "quantity",
                        title: "取酒数量",
                        width: '25%'
                    }],
                    data: _this.theDeposit.take_goods
                });
            },

            // 初始化寄存详情操作记录
            innitDetOperLogTable: function() {
                let _this = this;
                $(_this.$refs.depositDetOperLogTable).bootstrapTable("destroy");
                $(_this.$refs.depositDetOperLogTable).bootstrapTable({
                    columns: [{
                        field: "create_time",
                        title: "操作时间",
                        width: '20%'
                    }, {
                        field: "type_name",
                        title: "类型",
                        width: '20%'
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: '20%'
                    }, {
                        field: "remark",
                        title: "备注",
                        width: '20%'
                    }],
                    data: _this.theDeposit.operation_log
                });
            },

        }
    }
</script>
<style lang="less" scoped>
    .deposit-det {
            button {
                margin: 0 30px 0 0;
            }
            .deposit-det-list {
                border-top: 8px solid #d7d7d7;
                padding: 0 0 20px;
                margin: 30px 0;
                background: #f3f3f3;
                h2 {
                    margin: 20px 0;
                    font-size: 20px;
                    font-weight: normal;
                    text-align: center;
                }
                label {
                    height: 40px;
                    padding: 0;
                    margin: 0 0 0;
                    line-height: 40px;
                    font-size: 14px;
                    text-align: right;
                }
                span {
                    min-height: 40px;
                    padding-left: 0;
                    line-height: 40px;
                    font-size: 14px;
                }
            }
            h3 {
                margin: 30px 0 20px;
                font-size: 18px;
                font-weight: normal;
            }
        }
</style>